module.exports = __webpack_public_path__ + "img/domains.fc561fe4.svg";